import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var BaseCommand = /*#__PURE__*/function () {
  function BaseCommand(payload, params) {
    _classCallCheck(this, BaseCommand);
    _defineProperty(this, "payload", void 0);
    _defineProperty(this, "uuid", void 0);
    this.payload = payload !== null && payload !== void 0 ? payload : null;
    this.uuid = (params === null || params === void 0 ? void 0 : params.uuid) || "".concat(Math.random()).split('.')[1];
  }
  _createClass(BaseCommand, [{
    key: "type",
    get: /** Тип можно получить как у экземпляра, так и у класса */
    function get() {
      return this.constructor.type;
    }
  }]);
  return BaseCommand;
}();

// FIXME: Мониторить создание дубликатов команд по type
_defineProperty(BaseCommand, "type", void 0);
export var DefineCommand = function DefineCommand(commandType) {
  return function (target) {
    return Object.defineProperty(target, 'type', {
      value: commandType,
      writable: false,
      enumerable: false,
      configurable: false
    });
  };
};